import type { RoofTopI } from 'declarations/dto/roofTops';

/**
 * Returns oemFamilyId for the given roofTopId from the roofTops list.
 */
export const getOemFamilyIdByRoofTopId = (
  roofTopId: string | undefined,
  roofTopsList: RoofTopI[] | null | undefined
): string | undefined => {
  if (!roofTopId || !roofTopsList?.length) return undefined;
  const rooftop = roofTopsList.find((r): boolean => r.id === roofTopId);
  return rooftop?.oemFamilyId;
};
